import { customElement, property, query } from 'lit/decorators.js';
import { WEB_COMPONENT_IOC_SCAN_INDICATOR } from '../../../../../../../../webcomponents.constants';
import { html, LitElement, TemplateResult } from 'lit';
import { GzCheckboxWebComponent } from '../../../../../../../../ui/gzCheckbox';
import { styles } from '../view/style';
import { GzChipsGeneratorInputWebComponent } from '../../../../../../../../ui/gzChipsGeneratorInput';
import { IndicatorTypes, IocEvents } from '../../../types';

@customElement(WEB_COMPONENT_IOC_SCAN_INDICATOR)
export class IocScanIndicatorWebComponent extends LitElement {
  static get styles() {
    return styles;
  }

  @property({
    attribute: true,
    reflect: true,
  })
  public indicatorType: IndicatorTypes;

  @property({
    attribute: true,
    reflect: true,
  })
  public mainLabel: string;

  @property({
    attribute: true,
    reflect: true,
  })
  public checkboxLabel: string;

  @property({
    type: Boolean,
    attribute: true,
    reflect: true,
  })
  checkedByDefault = false;

  @property({
    attribute: true,
    reflect: true,
  })
  public textareaPlaceholder: string;

  @property({
    attribute: true,
    reflect: true,
  })
  public inputValidationRegex: string;

  @property({
    attribute: true,
    reflect: true,
  })
  public inputMaxChars: number;

  @property({
    attribute: true,
    reflect: true,
  })
  public hintText: string;

  @property({
    attribute: true,
    reflect: true,
  })
  public notUniqueErrorMessage: string;

  @property({
    attribute: true,
    reflect: true,
  })
  public invalidItemErrorMessage: string | undefined;

  @query('#indicatorCheckbox')
  private indicatorCheckbox: GzCheckboxWebComponent;

  @query('#indicatorFormContainer')
  private indicatorFormContainer: HTMLDivElement;

  @query('#chipsGenerator')
  private chipsGenerator: GzChipsGeneratorInputWebComponent;

  private chipsValues: Array<string> = [];

  protected firstUpdated() {
    this.indicatorCheckbox.addEventListener('change', this.onCheckboxChange.bind(this));
    this.chipsGenerator.addEventListener('change', this.onValueChange.bind(this));

    if (this.checkedByDefault) {
      this.indicatorCheckbox.checked = true;
      this.indicatorFormContainer.classList.remove('invisible-form');
    }
  }

  private onCheckboxChange() {
    if (this.indicatorCheckbox.checked) {
      this.indicatorFormContainer.classList.remove('invisible-form');
    } else {
      this.indicatorFormContainer.classList.add('invisible-form');
    }

    this.dispatchEvent(
      new CustomEvent(IocEvents.CATEGORY_TOGGLED, {
        detail: {
          type: this.indicatorType,
          checked: this.indicatorCheckbox.checked,
          values: this.chipsValues,
        },
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );
  }

  private onValueChange(event) {
    event.stopPropagation();
    let newEvent;
    const allValues = event.detail.value;
    const newValues = allValues.filter(value => !this.chipsValues.includes(value));

    if (newValues.length) {
      newEvent = new CustomEvent(IocEvents.INDICATOR_ADDED, {
        detail: {
          type: this.indicatorType,
          values: newValues,
        },
        bubbles: true,
        cancelable: true,
        composed: false,
      });
    } else {
      const removedValue = this.chipsValues.filter(value => !allValues.includes(value))[0];

      newEvent = new CustomEvent(IocEvents.INDICATOR_REMOVED, {
        detail: {
          type: this.indicatorType,
          value: removedValue,
        },
        bubbles: true,
        cancelable: true,
        composed: false,
      });
    }

    this.dispatchEvent(newEvent);
    this.chipsValues = event.detail.value;
  }

  protected render(): TemplateResult {
    return html`
      <gz-checkbox id="indicatorCheckbox" label="${this.checkboxLabel}" class="field-container"></gz-checkbox>
      <div id="indicatorFormContainer" class="invisible-form">
        <gz-chips-generator-input
          id="chipsGenerator"
          validationRegex="${this.inputValidationRegex}"
          .inputMaxChars="${this.inputMaxChars}"
          .strings="${{
            label: this.mainLabel,
            placeholder: this.textareaPlaceholder,
            invalidItemErrorMessage: this.invalidItemErrorMessage,
            notUniqueErrorMessage: this.notUniqueErrorMessage,
            hintText: this.hintText,
          }}"
          inputLines="3"
        ></gz-chips-generator-input>
      </div>
    `;
  }
}
